import { Injectable } from '@angular/core';

@Injectable()
export class AppSettings {
        public static production: boolean;
        public ENV: string;
        public Packaging2APIUrl: string;
        public Packaging2APIUrlV2: string;
        public Packaging2UIUrl: string;
        public WarpPartAPIUrl: string;
        public WarpStorageAPIImageBaseUrl: string;
        public SupplierPortalUrl: string;
        public SupplierPortalSignOutUrl: string;
        public OpenId_BaseUrl: string;
        public OpenId_AuthorizationUrl: string;
        public OpenId_RevokeUrl: string;
        public OpenId_ClientID: string;
        public OpenId_RedirectUrl: string;
        public OpenId_LogoutUrl: string;
        public RequestAccessUrl: string;
        public SupportTicketUrl: string;
}
